import {
  ITochiChicken,
  ITochiTextureMaterial,
} from "@snackpass/snackpass-types";
import { TextureShader } from "src/utils/Tochi/TochiShaders";
import { ShaderMaterial, TextureLoader, UniformsUtils } from "three";
import TochiMaterial from "./TochiMaterial";
import { stringToColor } from "./utils";

export default class TextureMaterial implements TochiMaterial {
  material?: ShaderMaterial;
  map: string;

  constructor(props: ITochiTextureMaterial) {
    this.map = props.map;
  }

  load = async (): Promise<void> => {
    const shader = TextureShader();
    const u = UniformsUtils.clone(shader.uniforms);
    const vs = shader.vertexShader;
    const fs = shader.fragmentShader;

    u.map.value = new TextureLoader().load(this.map);
    u.fresnelColor.value = stringToColor("white");
    u.fresnelScale.value = 0.35;

    const mat = new ShaderMaterial({
      uniforms: u,
      vertexShader: vs,
      fragmentShader: fs,
    } as any);
    this.material = mat;
  };

  get = async () => {
    if (!this.material) {
      await this.load();
    }
    return this.material!;
  };

  setChicken = (chicken: ITochiChicken) => {};
}
